module.exports = __webpack_public_path__ + "img/MyCards.279978aa.svg";